import type { DocumentStatus, ShortDocument, YscDocument } from '@yescapa-dev/ysc-api-js/legacy'
import { Constants } from '@yescapa-dev/ysc-api-js/legacy'

export const documentIsValidated = (document: ShortDocument | YscDocument) => {
  const statuses: Partial<DocumentStatus>[] = [Constants.DOCUMENTS.STATUS.VALIDATED, Constants.DOCUMENTS.STATUS.NEEDDOC]
  return statuses.includes(document.status)
}
